import axios from 'axios';
import config from '../config';
import { showError } from '../utils';

export function dashboardApi(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/console/pwa`, {
      headers,
      params: {
        v: config.version,
      },
    })
    .then((resp) => {
      const responseBody = resp.data;
      const responseCode = resp.status;
      if (responseCode === 200) {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      // throw err;
    });
}

export function consultationTab(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/console/care`, {
      headers,
      params: {
        v: config.version,
      },
    })
    .then((resp) => {
      const responseBody = resp.data;
      const { message } = responseBody;
      if (message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      // throw err;
    });
}

export function homeTab(authToken) {
  const headers = {
    authorization: authToken,
  };

  const fetchUpgradePackages = () =>
    axios
      .get(`${config.apiBaseUrl}/labs-v3/upgrade-packages`, {
        headers,
        params: {
          v: config.version,
        },
      })
      .then((resp) => resp.data)
      .catch(() => null);

  return axios
    .get(`${config.apiBaseUrl}/console/home`, {
      headers,
      params: {
        v: config.v2,
      },
    })
    .then(async (resp) => {
      const responseBody = resp.data;
      const { message } = responseBody;
      if (message !== 'success') {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }

      // `ahc-lead-packages` (and `upgrade-order-packages`) should be hydrated from `labs-v3/upgrade-packages`.
      // Mirrors behavior in `src-pb-pass` and enables upsell cards on Home.
      try {
        const home = Array.isArray(responseBody.home) ? responseBody.home : [];

        const upgradeResp = await fetchUpgradePackages();
        const packages = Array.isArray(upgradeResp?.data?.packages)
          ? upgradeResp.data.packages
          : [];

        if (packages.length > 0) {
          const hydrateCategory = (category, fallbackTitle) => {
            const idx = home.findIndex((c) => c && c.category === category);
            const section = idx >= 0 ? home[idx] : null;
            const cards = Array.isArray(section?.cards) ? section.cards : [];
            const nextSection = {
              ...(section || { category, title: fallbackTitle }),
              cards: [
                {
                  ...(cards[0] || {}),
                  packages,
                },
              ],
            };
            if (idx >= 0) home[idx] = nextSection;
            else home.push(nextSection);
          };

          hydrateCategory('ahc-lead-packages', 'AHC Packages');
          hydrateCategory('upgrade-order-packages', 'Recommended Packages');
          responseBody.home = home;
        }
      } catch (e) {
        // Swallow errors; return original home payload.
      }

      return responseBody;
    })
    .catch((err) => {
      showError(err);
      // throw err;
    });
}

export function endChat(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/users/chat/close?init=0`, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      const { message } = responseBody;
      if (message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      // throw err;
    });
}

export function updateProfile(body, authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .post(`${config.apiBaseUrl}/users/update/profile`, body, { headers })
    .then((resp) => {
      const responseBody = resp.data;
      const { message } = responseBody;
      if (message === 'profileUpdated') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      // throw err;
    });
}

export function popup(authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .get(`${config.apiBaseUrl}/console/popups`, {
      headers,
      // params: {
      //   v: config.version,
      // },
    })
    .then((resp) => {
      const responseBody = resp.data;
      const responseCode = resp.status;
      if (responseCode === 200) {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      // throw err;
    });
}
